import { Trans } from '@lingui/macro';
import { ButtonLink } from 'components/ButtonLink/ButtonLink';
import styles from './BackButton.module.css';

type TProps = {
  href?: string;
  onClick?: () => void;
};

export const BackButton = ({ href, onClick }: TProps) => {
  return (
    <ButtonLink
      href={href}
      className={styles.wrapper}
      linkClassName={styles.backButton}
      onClick={onClick}
      icon="arrowLeft"
      iconPosition="left"
    >
      <Trans>Back</Trans>
    </ButtonLink>
  );
};
